<template>
	<div>
		<v-row>
			<v-col cols="12" md="12" class="d-flex flex-wrap">
				<v-chip class="mx-2" color="success" outlined>
					<v-icon left>
						mdi-account-outline
					</v-icon>
					{{ data.member.fullName }}
					(&lrm;{{ data.member.userName }})
				</v-chip>
				<v-chip class="mx-2" color="success" outlined>
					<v-icon left small>
						mdi-cellphone
					</v-icon>
					موبایل: {{ data.member.mobile }}
				</v-chip>
			</v-col>
		</v-row>
		<v-divider class="my-3" />
		<div>
			<v-tabs v-model="activeTab">
				<v-tabs-items v-model="activeTab" touchless>
					<v-tab-item :key="0">
						<v-row v-if="requests && requests.length > 2">
							<v-col cols="12" md="12" class="text-center">
								<v-btn class="mx-auto" color="green" dark @click="add">
									<v-icon dark>
										mdi-plus-circle-outline
									</v-icon>
									ثبت درخواست جدید
								</v-btn>
							</v-col>
						</v-row>
						<v-row v-if="loading">
							<v-col cols="12">
								<div class="success--text text-h4 text-center">
									در حال دریافت اطلاعات ...
								</div>
							</v-col>
						</v-row>
						<v-row v-else-if="!requests || requests.length == 0">
							<v-col cols="12">
								<div class="red--text text-h4 text-center">
									تاکنون وامی برای این شخص ثبت نشده است.
								</div>
							</v-col>
						</v-row>
						<v-row v-else class="loan-cards">
							<v-col v-for="request in requests" :key="request.id" cols="12" md="12">
								<v-card style="overflow:hidden" class="card ma-2" elevation="3">
									<div class="d-flex grey lighten-2">
										<v-col cols="6" md="3" class="text-center">
											<div>شماره درخواست:</div>
											<div>{{ request.code }}</div>
										</v-col>
										<v-col cols="6" md="3" class="text-center">
											<div>نوع وام:</div>
											<div>{{ request.loanModel.title }}</div>
										</v-col>
										<v-col cols="6" md="3" class="text-center">
											<div>تاریخ درخواست:</div>
											<div>{{ request.requestDate_Persian.date }}</div>
										</v-col>
										<v-col cols="6" md="3" class="text-center">
											<div>وضعیت درخواست:</div>
											<div>{{ request.str_Status }}</div>
										</v-col>
									</div>
									<div v-if="request.userLoan">
										<v-row>
											<v-col cols="12" sm="4">
												<v-list-item three-line>
													<v-list-item-content>
														<v-list-item-title class="headline mb-3 pb-2 secondary--text" style="border-bottom: 1px dashed rgb(191 191 191);">
															<span class="black--text">نوع وام:</span> {{ request.userLoan.loanModel.title }}
														</v-list-item-title>
														<v-list-item-subtitle class="secondary--text"><span class="black--text">شماره وام:</span> {{
															request.userLoan.code }}</v-list-item-subtitle>
														<v-list-item-subtitle class="secondary--text"><span class="black--text">شماره فرعی:</span> {{
															request.userLoan.secondaryCode || 'ندارد' }}</v-list-item-subtitle>
														<v-list-item-subtitle class="secondary--text"><span class="black--text">تاریخ شروع:</span> {{
															request.userLoan.startDate_Persian.date }}</v-list-item-subtitle>
														<v-list-item-subtitle class="secondary--text"><span class="black--text">مبلغ وام:</span> {{
															request.userLoan.amount.toString().toPriceFormat() }} تومان</v-list-item-subtitle>
														<v-list-item-subtitle class="secondary--text"><span class="black--text">باز پرداخت با
																بهره:</span> {{ request.userLoan.payableAmount.toString().toPriceFormat() }}
															تومان</v-list-item-subtitle>
														<v-list-item-subtitle class="secondary--text"><span class="black--text">تعداد اقساط:</span> {{
															request.userLoan.month }} {{ (request.userLoan.monthGap > 1 ? `قسط
															${request.userLoan.monthGap} ماهه` : "") }}</v-list-item-subtitle>
														<v-list-item-subtitle class="secondary--text"><span class="black--text">مبلغ هر قسط:</span> {{
															request.userLoan.installment.toString().toPriceFormat() }} تومان</v-list-item-subtitle>
													</v-list-item-content>
												</v-list-item>

											</v-col>
											<v-col cols="12" sm="4">
												<v-list-item three-line>
													<v-list-item-content>
														<v-list-item-title class="headline mb-3 pb-2" style="border-bottom: 1px dashed rgb(191 191 191);">
															بازپرداخت ها
														</v-list-item-title>
														<v-list-item-subtitle class="secondary--text"><span class="black--text">تعداد اقساط
																پرداختی:</span> {{ request.userLoan.paidCount }}</v-list-item-subtitle>
														<v-list-item-subtitle class="secondary--text"><span class="black--text">اقساط پرداخت
																شده:</span> {{ request.userLoan.paid.toString().toPriceFormat() }}
															تومان</v-list-item-subtitle>
														<v-list-item-subtitle>
															<span v-if="request.userLoan.delays === 0" class="">دیرکرد/زودکرد:</span>
															<span v-else-if="request.userLoan.delays > 0" class="black--text">دیرکرد:</span>
															<span v-else class="black--text">زودکرد:</span>
															<span class="mr-1" :class="request.userLoan.delays > 0 ? 'red--text' : request.userLoan.delays < 0 ? 'success--text' : ''">{{ Math.abs(request.userLoan.delays).toString().toPriceFormat() }} تومان</span>
														</v-list-item-subtitle>
														<v-list-item-subtitle class="">
															<span :class="[request.userLoan.discount === 0 ? '' : 'black--text']">
																تخفیف:
															</span>
															<span :class="[request.userLoan.discount === 0 ? '' : 'secondary--text']">{{ request.userLoan.discount.toString().toPriceFormat() }} تومان</span>
														</v-list-item-subtitle>
														<v-list-item-subtitle class="secondary--text"><span class="black--text">مبلغ باقیمانده:</span>
															{{ Math.abs(request.userLoan.remain).toString().toPriceFormat() }} تومان <span class="success--text" v-if="request.userLoan.remain < 0">بستانکار</span><span class="red--text" v-if="request.userLoan.remain > 0">بدهکار</span></v-list-item-subtitle>
														<v-list-item-subtitle class="secondary--text"><span class="black--text">تسویه شده:</span> {{
															request.userLoan.isCheckouted ? 'بلی' : 'خیر' }}</v-list-item-subtitle>
														<v-list-item-subtitle class="secondary--text" v-if="request.userLoan.isCheckouted">
															<span class="black--text">تاریخ تسویه:</span> {{ request.userLoan.checkoutDate_Persian.date
															}}
														</v-list-item-subtitle>
													</v-list-item-content>
												</v-list-item>

											</v-col>
											<v-col cols="12" sm="4">
												<v-list-item three-line>
													<v-list-item-content>
														<v-list-item-title class="headline mb-3 pb-2" style="border-bottom: 1px dashed rgb(191 191 191);">
															توضیحات:
														</v-list-item-title>
														<div style="white-space: pre-line;">
															{{ request.userLoan.description ? request.userLoan.description : 'توضیحاتی ثبت نشده است.' }}
														</div>
													</v-list-item-content>

													<div class="checkouted-mark" v-if="request.userLoan.isCheckouted">تسویه شده</div>
												</v-list-item>
											</v-col>
										</v-row>

										<v-card-actions class="flex-wrap">
											<v-btn outlined rounded text @click="showAssurances(request.userLoan)">
												تضامین
											</v-btn>
											<v-btn outlined rounded text @click="showCheckoutAmount(request.userLoan)">
												مشاهده مبلغ تسویه آنی
											</v-btn>
											<v-spacer />
											<v-btn @click="print(request.userLoan, 3)" fab dark small outlined color="primary" :loading="printLoadingId === request.userLoan.id" class="mx-1">
												<v-icon dark>
													mdi-printer-outline
												</v-icon>
											</v-btn>
										</v-card-actions>

									</div>
									<div v-else class="red--text pa-3 text-center">
										تاکنون این درخواست تبدیل به وام نشده است.
									</div>
								</v-card>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" md="12" class="text-center">
								<v-btn v-if="!loading" class="mx-auto" color="green" dark @click="add">
									<v-icon dark>
										mdi-plus-circle-outline
									</v-icon>
									ثبت درخواست جدید
								</v-btn>
							</v-col>
						</v-row>
					</v-tab-item>
				</v-tabs-items>
			</v-tabs>
		</div>

		<v-dialog v-model="dialogAssurance" scrollable persistent max-width="900px">
			<v-card>
				<v-card-title>
					<div><span class="headline">تضامین</span></div>
					<v-spacer />
					<v-btn @click="dialogAssurance = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<Assurance ref="assurance" v-if="dialogAssurance" :data="selectedUserLoan" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogCheckoutAmount" max-width="400px">
			<v-card>
				<v-card-title>
					<div></div>
				</v-card-title>
				<v-container>
					<div v-if="checkoutAmount === checkoutAmount2">
						<div style="text-align: center;">
							<div class="mb-2">مبلغ قابل تسویه</div>
							<h3 :class="[checkoutAmount > 0 ? 'red--text' : 'success--text']">
								{{ checkoutAmount.toString().toPriceFormat() }} <span v-if="!isNaN(checkoutAmount)">{{ checkoutAmount > 0 ? 'بدهکار' : 'بستانکار' }}</span>
							</h3>
						</div>
					</div>
					<div v-else>
						<div style="text-align: center;border-bottom: 1px dashed #ddd;padding-bottom: 5px;margin-bottom: 5px;">
							<div class="mb-2">مبلغ قابل تسویه با کسر ضریب زودکرد</div>
							<h3 :class="[checkoutAmount > 0 ? 'red--text' : 'success--text']">
								{{ checkoutAmount.toString().toPriceFormat() }} <span v-if="!isNaN(checkoutAmount)">{{ checkoutAmount > 0 ? 'بدهکار' : 'بستانکار' }}</span>
							</h3>
						</div>
						<div style="text-align:center">
							<div class="mb-2">مبلغ قابل تسویه با کسر بهره ماهانه</div>
							<h3 :class="[checkoutAmount2 > 0 ? 'red--text' : 'success--text']">
								{{ checkoutAmount2.toString().toPriceFormat() }} <span v-if="!isNaN(checkoutAmount2)">{{ checkoutAmount2 > 0 ? 'بدهکار' : 'بستانکار' }}</span>
							</h3>
						</div>
					</div>
				</v-container>
				<v-card-actions>
					<v-spacer />
					<v-btn @click="dialogCheckoutAmount = false">
						بستن
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogLoanRequest" scrollable persistent max-width="1000px">
			<v-card>
				<v-card-title>
					<span class="headline">درخواست وام ({{ data.member.fullName }})</span>
					<v-spacer />
					<v-btn @click="dialogLoanRequest = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<modify-request ref="modifyRequest" v-if="dialogLoanRequest" :data="selectedRequest" :user="data.member" @callbck="callbck" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<div id="printHtml2" style="display: none;">
			<userLoan-default-printHtml v-if="selectedUserLoan && printToggler && printType === 3" @ready="applyPrintReady()" :userLoanId="selectedUserLoan.id" area="agent" />
		</div>

		<confirm-dlg ref="confirm" />
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'

	export default {
		name: 'LoanInstallmentsView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			Assurance: () => import('@/components/forms/Assurance.vue'),
			ModifyRequest: () => import('./ModifyLoanRequest.vue'),
			'userLoan-default-printHtml': () => import('@/components/prints/DefaultUserLoanPrintHtml')
		},
		props: {
			data: { type: Object },
		},
		data() {
			return {
				userloan: null,
				activeTab: 0,
				loading: false,
				errorMessages: '',
				localData: {},
				checkoutAmount: 0,
				checkoutAmount2: 0,
				dialogCheckoutAmount: false,
				dialogAssurance: false,
				dialogLoanRequest: false,
				selectedUserLoan: null,
				selectedRequest: {},
				requests: [],
				printReady: false,
				printType: 0,
				printLoadingId: '',
				printToggler: false
			}
		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				this.activeTab = 0
				this.loading = true
				api.get('agent/userloan/GetLoansByUserId/' + this.data.member.id, null)
					.then(
						response => {
							this.requests = response
						})
					.catch(err => {
						toast.error(err.message)
					}).finally(x => {
						this.loading = false
					})
			},
			showCheckoutAmount(userLoan) {
				this.dialogCheckoutAmount = true
				this.checkoutAmount = "در حال دریافت اطلاعات..."
				this.checkoutAmount2 = "در حال دریافت اطلاعات..."
				api.get('agent/userloan/getCheckoutAmount/' + userLoan.id, null)
					.then(
						response => {
							this.checkoutAmount = response.item1
							this.checkoutAmount2 = response.item2
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			showAssurances(userLoan) {
				this.dialogAssurance = true
				this.selectedUserLoan = userLoan
			},
			add() {
				this.dialogLoanRequest = true
				this.selectedRequest = { id: emptyId }
			},
			callbck(result) {
				if (result == 'refresh') {
					this.loadData()
					return
				}
				this.dialogLoanRequest = false
				if (result) { this.loadData() }
			},
			applyPrintReady() {
				this.printReady = true
			},
			print(data, type) {
				this.selectedUserLoan = null
				this.printReady = false
				this.printLoadingId = data.id
				this.printToggler = false
				this.printType = 0
				setTimeout(() => {
					this.selectedUserLoan = data
					let timer = 0
					this.printToggler = true
					this.printType = type
					let interval = setInterval(() => {
						timer++
						if (timer > 300 || this.printReady) {
							clearInterval(interval)
							this.printLoadingId = ''
						}
						if (this.printReady) {
							console.log('aaaaaaaaaaaa')
							printJS({
								printable: 'printHtml2',
								type: 'html',
								scanStyles: false, // If true inline styles will be removed
								targetStyles: ['*'],
								style: `
										@font-face {
											font-family:'YekanP';
											src:url(/iranyekanweb.ttf) format('truetype'),
											url(/iranyekanweb.woff) format('woff-variations'),
											url(/iranyekanweb.woff) format('woff'),
											url(/iranyekanweb.woff2) format('woff2');
											font-display:fallback
										}
										#printHtml2 {
												display: block !important;
												font-family: 'YekanP', sans-serif;
										}
									`
							})
						}
						setTimeout(() => {
							this.printToggler = false
						}, 3000)
					}, 100)
				}, 100)
			},
		},
	}
</script>
<style scoped>
	.v-tabs .v-tabs-bar {
		display: none;
	}
</style>
